import React from 'react';
import { NavLink } from "react-router-dom";
import * as Icon from 'react-feather';
import { NotificationManager } from '../../helpers/NotificationManager';
import { Screen } from '../App/Screen';
import { RoleForm } from './Form';
import { EntityService } from '../../services/EntityService';

export class CreateRoleContainer extends React.Component {
   constructor(props) {
       super(props);

       this.RoleService = new EntityService("Roles");
       
       this.createRole = this.createRole.bind(this);
   }

   createRole(role) {
       var model = {
          ...role
       };

       this.RoleService.create(model).then(
           response => {
               const role = response.data;
               this.props.history.push('/roles/edit/' + role.id);
               NotificationManager.success('The role ' + role.name + ' was created successfully', 'Role Created');
           },
           response => {
               NotificationManager.error('Role was not created', 'Error', 10000);
           },
       );
   }

   render() {
       const isLoaded = true;

       // Build the Screen menu.
       // This will be passed to the Screen component so that it can be rendered in the relevant place.
       const screenMenu = (
           <>
               <NavLink  to="/roles" className="btn btn-sm btn-outline-secondary">
                   <Icon.ArrowLeftCircle className="feather" />&nbsp;Back to Roles List
               </NavLink>
           </>
       );

       // Define the setting for the screen loader
       // This object will be passed to the Screen component,
       // Which will determine how and if the loader should be displayed
       const screenLoader = {
           isEnabled: true,
           isLoaded: isLoaded,
           text: "Loading Create Role Form..."
       };

       return (
           <Screen title="Create Role" menu={screenMenu} loader={screenLoader}>
               <RoleForm
                   ref={(el) => this.roleForm = el}
                   handleSave={this.createRole}
                   
               />
           </Screen>
       );
   }
}